enum InvoiceTaxMode {
  NoTax = 'NoTax',
  Inclusive = 'Inclusive',
  Exclusive = 'Exclusive'
}

export default InvoiceTaxMode;
